<app-main-layout
  [clickNext]="onClickNext"
  [clickBack]="onClickBack"
  [activateNextButton$]="nextButtonState.activateNext$"
  >
  <form [formGroup]="homeownerForm">
    <div class="ownership-check">
      <h2>What type of property is this?</h2>
      <app-radio [radioGroup]="propertyTypeRadioGroup" [rounded]="true"></app-radio>
      @if (!showOtherBlock) {
        <div class="text-link">
          <a (click)="switchOther(true, $event)" href="#">Other</a>
        </div>
      }
      @if (showOtherBlock) {
        <div>
          <div class="input">
            <button
              class="remove-btn"
              (click)="switchOther(false)"
              >
              <img
                class="icon"
                src="/assets/icons/trash-2.svg"
                alt="remove-btn"
                aria-hidden="true"
                />
            </button>
            <app-form-group
              label="Other"
              id="propertyTypeOtherText"
              [required]="true"
              [counter]="otherTextfieldMaxLength"
              formControlName="propertyTypeOtherText"
              placeholder="Enter your type of property here"
              >
            </app-form-group>
          </div>
        </div>
      }
    </div>
    <div class="main-heading">
      <h2>Who owns the home?</h2>
      <div class="cs-inner-html-16">
        <p>We’ll need to have all the homeowners involved in the process.</p>
      </div>
    </div>
    <div class="contact-form">
      <app-radio [radioGroup]="radioGroup" [rounded]="true"></app-radio>
      @if (
        homeownerForm.controls['onlyHomeowner'].value ===
        HOMEOWNER_INFO_MAP.homeownerFormRadioButtons[1]
        .unique_name
        ) {
        <div
          >
          <h2 class="mb-24">Please add name and phone numbers of all additional homeowners</h2>
          @for (homeowner of homeownersList; track homeowner; let i = $index) {
            <div
              class="homeowner-block"
              [formGroup]="homeowner"
              >
              <div class="input">
                <div class="homeowner-block_label-block">
                  <span class="homeowner-block_label"
                    >Additional Homeowner {{ i + 1 }}</span
                    >
                    <button class="remove-btn" (click)="onRemoveHomeOwner(i)">
                      <img
                        class="icon"
                        src="/assets/icons/trash-2.svg"
                        alt="remove-btn"
                        aria-hidden="true"
                        />
                    </button>
                  </div>
                  <div class="name">
                    <app-form-group
                      label="First Name"
                      id="firstName"
                      [required]="true"
                      formControlName="firstName"
                    ></app-form-group>
                    <app-form-group
                      label="Last Name"
                      id="lastName"
                      [required]="true"
                      formControlName="lastName"
                    ></app-form-group>
                  </div>
                </div>
                <div class="input">
                  <app-form-group
                    label="Phone Number"
                    id="phone"
                    formControlName="phone"
                    type="phone"
                  ></app-form-group>
                </div>
              </div>
            }
            <button class="add-btn" (click)="onAddHomeowner()">
              <img
                class="icon"
                src="/assets/icons/add-homeowner.svg"
                alt="add-btn"
                aria-hidden="true"
                />
              Add additional homeowner
            </button>
          </div>
        }
      </div>
    </form>

  </app-main-layout>
